import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  SimpleGrid,
  Button,
  useColorMode,
  Input,
} from "@chakra-ui/react";
import card from "components/Card/Card";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";
import { FaSearch } from "react-icons/fa";

function Page() {
  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card direction="column" alignItems="center" justifyContent="center">
        <Flex
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
          gap={4}
        >
          <Input placeholder="Wpisz nick" size="lg" variant="outline"></Input>
          <Input type="date" placeholder="Od" size="lg" variant="outline" width={"200px"} />
          <Input type="date" placeholder="Do" size="lg" variant="outline" width={"200px"} />
          <Button
            colorScheme="red"
            variant="solid"
            size="lg"
          >
            Wyszukaj
          </Button>
        </Flex>
      </Card>
    </Flex>
  );
}

export default Page;
